<template>
    <van-popup v-model="show" round>
        <div :class="`ml-dialog ml-dialog-${type}`">
			<div class="ml-dialog-title">{{title}}</div>
			<div class="ml-dialog-content">
				<slot>
					<div>{{content}}</div>
				</slot>
			</div>

			<div class="ml-dialog-bottom">
				<div v-if="type === 'alert'" class="ml-dialog-cancel" @click="handleCancel">{{cancelText}}</div>
				<div v-if="type === 'confirm'" class="ml-dialog-confirm-cancel" @click="handleCancel">{{cancelText}}</div>
				<div v-if="type === 'confirm'" class="ml-dialog-confirm-confirm" @click="handleConfirm">{{confirmText}}</div>
			</div>

			<div class="ml-dialog-status">
				<img v-if="status === 'success'" src="../images/dialog/success.png" alt=""  />
				<img v-if="status === 'warning'" src="../images/dialog/warning.png" alt="" />
			</div>
		</div>
    </van-popup>
</template>

<script>
export default {
    data() {
        return {

        }
	},
	model: {
		prop: 'show',
		event: 'change'
	},
    props: {
        show: {
            type: Boolean,
            default: false
		},
		title: {
			type: String,
			default: ""
		},
		content: {
			type: String,
			default: ""
		},
		confirmText: {
			type: String,
			default: "确定"
		},
		cancelText: {
			type: String,
			default: "取消"
		},
		type: {
			type: String,
			default: "alert"
		},
		status: {
			type: String,
			default: ""
		}
	},
	methods: {
		/**
            点击确定按钮时触发
            @param
            @return
        */
		handleConfirm() {
			this.$emit('change', false)
			this.$emit('confirm')
		},

		/**
            点击取消按钮时触发
            @param
            @return
        */
		handleCancel() {
			this.$emit('change', false)
			this.$emit('cancel')
		}
	}
}
</script>

<style lang="scss" scoped>
.ml-dialog-confirm {
	padding-bottom: 0.24rem;
}
.ml-dialog {
	width: 5.6rem;
	overflow: hidden;
	border-radius: 0.16rem;
	.ml-dialog-title {
		padding: 0.32rem;
		text-align: center;
		line-height: 0.42rem;
	}
	.ml-dialog-content {
		display: flex;
		//align-items: center;
		justify-content: center;
		padding: 0.18rem 0.48rem 0.28rem;
		min-height: 1.26rem;
		>div {
			text-align: left;
			font-size: 0.24rem;
			color: #564A4E;
		}
	}
	.ml-dialog-bottom {
		display: flex;
		flex-direction: row;
		justify-content: center;
		// .ml-dialog-confirm {
		// 	width: 3.2rem;
		// 	height: 0.88rem;
		// 	border-radius: 0.8rem;
		// 	text-align: center;
		// 	line-height: 0.88rem;
		// 	background: linear-gradient(90deg, #FEBABA 0%, #F86190 100%);
		// 	color: #fff;
		// }

		.ml-dialog-cancel {
			width: 3.2rem;
			height: 0.88rem;
			text-align: center;
			line-height: 0.88rem;
			border-top: 0.02rem solid #EFEFEF;
			color: #F86190;
		}

		.ml-dialog-confirm-cancel, .ml-dialog-confirm-confirm {
			width: 2.4rem;
			height: 0.88rem;
			border: 0.02rem solid #E56C90;
			border-radius: 0.16rem;
			text-align: center;
			line-height: 0.84rem;
			color: #F86190;
		}

		.ml-dialog-confirm-confirm {
			margin-left: 0.32rem;
			border: none;
			line-height: 0.88rem;
			color: #fff;
			background: linear-gradient(90deg, #FEBABA 0%, #F86190 100%);
		}
	}

	.ml-dialog-status {
		position: absolute;
		left: 0;
		right: 0;
		top: 0.32rem;
		width: 1.6rem;
		height: 1.6rem;
		margin: 0 auto;
		img {
			width: 100%;
			height: 100%;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/$dialog.vue